import React, { useState, useEffect } from 'react';
import './StaffFrontendSettingsPage.css';

const StaffFrontendSettingsPage = () => {
  const [settings, setSettings] = useState({
    maintenanceMode: false,
    betaFeatures: false,
  });

  useEffect(() => {
    const stored = localStorage.getItem('frontend_settings');
    if (stored) {
      setSettings(JSON.parse(stored));
    }
  }, []);

  const handleChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.checked });
  };

  const handleSave = () => {
    localStorage.setItem('frontend_settings', JSON.stringify(settings));
    alert('Frontend settings saved');
  };

  return (
    <div className="staff-frontend-settings-container">
      <h1>Frontend Settings</h1>
      <div>
        <label>
          <input
            type="checkbox"
            name="maintenanceMode"
            checked={settings.maintenanceMode}
            onChange={handleChange}
          />
          Maintenance Mode
        </label>
      </div>
      <div>
        <label>
          <input
            type="checkbox"
            name="betaFeatures"
            checked={settings.betaFeatures}
            onChange={handleChange}
          />
          Enable Beta Features
        </label>
      </div>
      <button onClick={handleSave}>Save Settings</button>
    </div>
  );
};

export default StaffFrontendSettingsPage;
